import { Box, styled, Typography } from "@mui/material";
import React from "react";
import roleReviewLogo from "../../assets/images/rolereview_logo.png";

function ReportHeader() {
  return (
    <SectionWrap component="section" sx={{ position: "relative" }}>
      <ContainerWrap>
        <HeaderInner>
          <LogoWrap>
            <img src={roleReviewLogo} alt="Role Review" />
          </LogoWrap>
          <TextWrap>
            <CustomHead component="h2" id="RolerevirTitle">
              Role Review
            </CustomHead>
            <CustomText id="RolerevirContent">
              Setting clear expectations is a key ingredient to ensure strong
              communication, employee engagement, and career success. Thanks for
              making an investment in clarity!
            </CustomText>
          </TextWrap>
        </HeaderInner>
      </ContainerWrap>
    </SectionWrap>
  );
}

export default ReportHeader;

const SectionWrap = styled(Box)(() => ({
  padding: "25px 0",
  background: "#1085AB",
}));

const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "1170px",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));

const HeaderInner = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "24px",
}));

const LogoWrap = styled(Box)(() => ({
  flexShrink: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  "& img": {
    width: "110px",
    height: "auto",
    display: "block",
  },
}));

const TextWrap = styled(Box)(() => ({
  flex: 1,
  minWidth: 0,
}));

const CustomHead = styled(Typography)(() => ({
  fontSize: "30px",
  fontWeight: "600",
  lineHeight: "1.2",
  color: "#FFFFFF",
  textAlign: "center",
  marginBottom: "5px",
  "@media (max-width: 575px)": {
    fontSize: "22px",
  },
  "&.capture-mode": {
    fontSize: "50px",
  },
}));

const CustomText = styled(Typography)(() => ({
  fontSize: "20px",
  fontWeight: "400",
  lineHeight: "1.5",
  color: "#FFFFFF",
  textAlign: "center",
  wordWrap: "break-word",
  overflowWrap: "break-word",
  whiteSpace: "normal",
  "@media (max-width: 575px)": {
    fontSize: "16px",
  },
}));
